import { Component, Input, OnInit, Output, inject } from "@angular/core";
import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MatButton } from "@angular/material/button";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AsyncPipe } from "@angular/common";
import { MatomoTracker } from "ngx-matomo-client";
import { RedirectService } from "@e-forsyning/common/router";

@Component({
    selector: "login-container",
    templateUrl: "./login-container.component.html",
    styleUrls: ["./login-container.component.scss"],
    imports: [MatButton, MatProgressSpinner, AsyncPipe]
})
export class LoginContainerComponent implements OnInit {
    @Input() public titel: string;
    @Input() public arbejder: boolean;
    public overskrift$: Observable<string>;

    // Modern Angular: Use inject() function instead of constructor injection
    private readonly indstillingerObserver = inject(UmbracoIndstillingerObserver);
    private readonly matomoTracker = inject(MatomoTracker);
    private readonly redirectService = inject(RedirectService);

    public ngOnInit(): void {
        this.overskrift$ = this.indstillingerObserver.valueChanges.pipe(map((value) => value.aktuelEforsyning.overskriftPaaLoginside));
    }

    public onSkiftForsyningClick(): void {
        this.matomoTracker.trackEvent("Login", "SkiftForsyningClick", "Skift forsyning");

        // Modern approach: Direct service call instead of parent-child communication
        this.redirectService.redirectTilVaerksListe();
    }
}
